export function get(object, path) {
  return path.reduce((xs, x) => (xs && xs[x] !== undefined ? xs[x] : undefined), object);
}

export function humanize(x, n = 6) {
  if (x === undefined) {
    return x;
  } else if (typeof x === "string") {
    return humanize(parseFloat(x));
  }

  return parseFloat(x.toFixed(n).replace(/\.?0*$/, ""));
}

export function remove_nulls_from(source_object) {
  const obj = {};
  for (let key of Object.keys(source_object)) {
    let value = source_object[key];
    if (value !== null) obj[key] = source_object[key];
  }
  return obj;
}

const COLORS = [
  "#D57DF5",
  "#9E3EC1",
  "#75049E",
  "#7A11A0",
  "#7A5F84",

  "#512f77",
  "#6758AA",
  "#4520E8",
  "#B0A2F2",
  "#6047D1",

  "#2F80ED",
  "#4071B2",
  "#0754BA",
  "#6680A3",
  "#1261C9",

  "#56CCF2",
  "#116B89",
  "#48ACCE",
  "#089BCC",
  "#049DD1",

  "#52FFD3",
  "#108769",
  "#4BEAC2",
  "#087F61",
  "#A7D3C8",

  "#5BCF74",
  "#00A1FC",
  "#5F8467",
  "#75CE88",
  "#4EFC74",

  "#96E964",
  "#B5F48D",
  "#58A826",
  "#68CC2A",
  "#A1D87F",

  "#FFCF71",
  "#E2A428",
  "#87692D",
  "#9E792F",
  "#C69125",

  "#F97255",
  "#896F6A",
  "#F7AE9E",
  "#9E361F",
  "#96311B",

  "#FF84CE",
  "#E8299B",
  "#AA5086",
  "#B24C89",
  "#7e69d7"
];

const AVAILABLE_COLORS = new Set(COLORS);
const COLORS_IN_USE = {};
const COLOR_MODEL_MAP = {};

export function getColorFromId(modelId) {
  if (COLOR_MODEL_MAP[modelId]) {
    return COLOR_MODEL_MAP[modelId];
  }

  let color = COLORS[hashFunction(modelId) % COLORS.length];

  let isCollision = COLORS_IN_USE[color] !== undefined && COLORS_IN_USE[color] !== modelId;

  if (isCollision) {
    for (let otherColor of AVAILABLE_COLORS) {
      color = otherColor;
      isCollision = false;
    }
  }

  if (!isCollision) {
    COLORS_IN_USE[color] = modelId;
    COLOR_MODEL_MAP[modelId] = color;
    AVAILABLE_COLORS.delete(color);
  } else {
    // just let the collision happen and move on
  }

  return color;

  /*
	TODO: make this less ugly
	return (
		"#" + (hashFunction(modelId) % 16777215).toString(16)
	);
	*/
}

function hashFunction(x) {
  var hash = 0;
  if (x.length == 0) {
    return hash;
  }
  for (var i = 0; i < x.length; i++) {
    var char = x.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}
